"use strict";

var SITE = SITE || {
  data: {
    url: '',
    $body: $('body'),
    $window: $(window),
    $MQ: 'LANDSCAPE',
    scrollTop: 0,
    lockTop: 0,
    winW: '',
    winH: '',
    jqXHR: '',
    scrollTopflag: false,
    transitonEnd: 'webkitTransitionEnd mozTransitionEnd msTransitionEnd oTransitionEnd transitionend',
    animationStart: 'webkitAnimationStart mozAnimationStart msAnimationStart oAnimationStart animationStart',
    animationEnd: 'webkitAnimationEnd mozAnimationEnd msAnimationEnd oAnimationEnd animationEnd'
  },
  common: {
    init: {}
  }
};
SITE.common = function (pageScript) {
  // コンストラクタ  =================================================================
  function init(pageScript) {
    setUtilityData();
    setBrowser();
    $('.anchorLink')[0] && initAnchorLink();
    pageScript && pageScript();
  }

  // public functions  ==========================================================
  /*
  *   UtilityDataの取得
  *   特定ページのみで使用するデータはページJSで取得すること。
  *
  */
  function setUtilityData() {
    SITE.data.url = window.location.pathname;
    getScrollTop();
    SITE.data.$window.on('scroll', getScrollTop);
    getWindowSize();
    SITE.data.$window.on('resize', function () {
      getWindowSize();
    });
  }
  var scrollFlag = false;
  function getScrollTop() {
    if (!scrollFlag) {
      requestAnimationFrame(function () {
        scrollFlag = false;
        SITE.data.$window.trigger('scroll.custom');
        SITE.data.scrollTop = SITE.data.$window.scrollTop();
      });
      scrollFlag = true;
    }
    return true;
  }
  function getWindowSize() {
    SITE.data.winW = SITE.data.$window.width();
    SITE.data.winH = SITE.data.$window.height();
    var cssContent = $('body').css('content');
    if (cssContent.indexOf('portrait') != -1) {
      SITE.data.$MQ = 'PORTRAIT';
    } else {
      SITE.data.$MQ = 'LANDSCAPE';
    }
    if (SITE.data.oldMQ && SITE.data.oldMQ !== SITE.data.$MQ) {
      SITE.data.$window.trigger('onBreakpointChange');
    }
    SITE.data.oldMQ = SITE.data.$MQ;
  }
  // HO TO USE
  // SITE.data.$window.on('onBreakpointChange', 実行文);

  /*
  *
  *  ブラウザ判定
  *
  */
  function setBrowser() {
    SITE.data.ua = {
      Safari: typeof window.chrome == 'undefined' && 'WebkitAppearance' in document.documentElement.style,
      Firefox: 'MozAppearance' in document.documentElement.style,
      IE: window.navigator.userAgent.toLowerCase().indexOf('msie') !== -1 || window.navigator.userAgent.toLowerCase().indexOf('trident') !== -1,
      IE9: window.navigator.appVersion.toLowerCase().indexOf('msie 9.') !== -1,
      ltIE9: typeof window.addEventListener === 'undefined' && typeof document.getElementsByClassName === 'undefined',
      Touch: typeof document.ontouchstart !== 'undefined',
      Pointer: window.navigator.pointerEnabled,
      MSPoniter: window.navigator.msPointerEnabled,
      Windows: window.navigator.userAgent.toLowerCase().indexOf('win') !== -1,
      Mac: window.navigator.userAgent.toLowerCase().indexOf('mac') !== -1,
      Mobile: window.navigator.userAgent.toLowerCase().indexOf('iphone') > 0 || window.navigator.userAgent.toLowerCase().indexOf('ipod') > 0 || window.navigator.userAgent.toLowerCase().indexOf('android') > 0 && window.navigator.userAgent.toLowerCase().indexOf('mobile') > 0,
      Tablet: window.navigator.userAgent.toLowerCase().indexOf('ipad') > 0 || window.navigator.userAgent.toLowerCase().indexOf('macintosh') > 0 && 'ontouchend' in document || window.navigator.userAgent.toLowerCase().indexOf('android') > 0 && window.navigator.userAgent.toLowerCase().indexOf('mobile') == -1
    };
    if (SITE.data.ua.Safari) {
      $('html').addClass('safari');
    }
    if (SITE.data.ua.Firefox) {
      $('html').addClass('firefox');
    }
    if (SITE.data.ua.IE) {
      $('html').addClass('ie');
    }
    if (SITE.data.ua.IE9) {
      $('html').addClass('ie9');
    }
    if (SITE.data.ua.ltIE9) {
      $('html').addClass('ie8');
    }
    if (SITE.data.ua.Tablet) {
      $('html').addClass('tablet');
    }
  }

  // event functions  =================================================================
  /*
  *
  *  アンカーリンク
  *
  */
  function initAnchorLink() {
    $('.anchorLink').on('click', function () {
      var href = $(this).attr("href"),
        target = $(href === "#" || href === "" ? 'html' : href),
        offset = target.offset().top;
      $('html, body').animate({
        scrollTop: offset
      }, 500);
      return false;
    });
  }

  // ページごと読み込み event functions  ==========================================================

  /*
  *
  *
  *   ストレージ set・get
  *
  */
  // セッションストレージ - セット
  function setSessionStrage(key, value) {
    if (!window.sessionStorage) return;
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {}
  }
  // ローカルストレージ - セット
  function setLocalStrage(key, value) {
    if (!window.localStorage) return;
    try {
      localStorage.setItem(key, value);
    } catch (err) {}
  }
  // セッションストレージ - ゲット
  function getSessionStrage(targetStrage) {
    var strage;
    if (!window.sessionStorage) return;
    try {
      strage = window.sessionStorage.getItem(targetStrage);
    } catch (err) {}
    return strage;
  }
  // ローカルストレージ - ゲット
  function getLocalStrage(targetStrage) {
    var strage;
    if (!window.localStorage) return;
    try {
      strage = window.localStorage.getItem(targetStrage);
    } catch (err) {}
    return strage;
  }

  /*
  *
  *   画像読み込み数カウンタ
  *   @target - jQueryオブジェクトで指定。指定された要素内のimgのロードを監視する。
  *   promiseを返すので、戻り値に対して.doneでコールバックを実装する。
  */
  function countImgLoaded(target, runnninng) {
    var deferred = new $.Deferred();
    var $img = target ? target.find('img') : $('img');
    var total = $img.length;
    var count = 0;
    $img.each(function () {
      var myImg = new Image();
      myImg.src = $(this).attr('src');
      myImg.onload = function () {
        count++;
        var progress = count / total;
        if (runnninng) {
          runnninng(progress);
        }
        if (count >= total) {
          deferred.resolve();
        }
      };
      myImg.onerror = function () {
        deferred.reject();
      };
    });
    return deferred.promise();
  }

  /*
  * スクロールロック
  *
  */
  function screenLock() {
    $('html').addClass('scrollLock');
  }
  ;
  function screenUnlock() {
    $('html').removeClass('scrollLock');
  }
  ;
  return {
    setSessionStrage: setSessionStrage,
    setLocalStrage: setLocalStrage,
    getSessionStrage: getSessionStrage,
    getLocalStrage: getLocalStrage,
    countImgLoaded: countImgLoaded,
    screenLock: screenLock,
    screenUnlock: screenUnlock,
    init: init
  };
}();